import { UTMParametersStatsType } from "../../types"

export const fetchParams = (
  range: number,
  type: UTMParametersStatsType,
  orgId?: string,
  loid?: string,
  parentUrl?: string,
  embed?: string
) => ({
  range,
  utm_key: type,
  org_id: orgId,
  loid,
  parent_url: parentUrl,
  embed
})

export const fetchOptions = {
  refetchOnMountOrArgChange: true
}
